export default function () {
  $('html')
    .removeClass('no-js')
    .addClass('js')
}
